<template>
  <div class="personal">
    <Nav/>
    <div style="height: 80px"></div>
    <div class="personal-bottom">
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
              <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
            <el-breadcrumb
              class="daohang"
              separator-class="el-icon-arrow-right"
            >
              <el-breadcrumb-item
                class="maxtitle"
                :to="{ path: '/yonghupaihangbang' }"
                >  <div class="title_box">
                 <span class="lines"></span>
                 <span>贡献排行版</span>
               </div>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="personal-bottom-bottom-right-bottom">
            <div class="waiceng">
              <!-- <span style="color: #ffffff">筛选时间</span> -->
              <!-- <el-date-picker
                                style="margin-left:20px;"
                              v-model="value1"
                              type="monthrange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
                            </el-date-picker> -->
              <div @click="sum" :class="{ 'detaultItem': classs == 2 }" class="all_list">
                总榜
              </div>
              <div @click="month" :class="{ 'detaultItem': classs == 1 }" class="all_list">
                月榜
              </div>
              <div @click="dey" :class="{ 'detaultItem': classs == 0 }" class="all_list">
                日榜
              </div>
              <!-- <div style="font-size:14px;color:#ffffff;text-align: center;line-height: 28px;width: 60px;height: 28px;background: #721EDC;border-radius: 4px;">查询</div> -->
            </div>
            <div class="table_list">
              <div class="tb_header">
                <div style="width: 10%; text-align: center">名次</div>
                <div style="width: 20%; text-align: center">UID</div>
                <div style="width: 35%; text-align: center">名称</div>
                <div style="width: 35%; text-align: center">贡献值</div>
              </div>
              <div
                v-for="(item, index) in paihangbanData"
                :key="index"
                class="tb_item"
              >
                <div style="text-align: center; width: 10%">T{{ index }}</div>
                <div style="text-align: center; width: 20%">
                  {{ item.userInfo.uid }}
                </div>
                <div style="text-align: center; width: 35%">
                  {{ item.userInfo.nickname }}
                </div>
                <div style="text-align: center; width: 35%; color: #32c5ff">
                  {{ item.contribution }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "../component/Nav.vue";

import slide from './template_slide.vue'

export default {
  name: "App",
  data() {
    return {
      b: 2,
      value1: "",
      paihangbanData: [], //数据
      roomids: null,
      classs: 2,
      activeName: 2,
    };
  },
  created() {
    this.cooke = localStorage.getItem("token");
    if(this.cooke ){
      this.$store.dispatch('getUserInfoData').then((result) => {
        this.roomid(result.userInfo.uid);
      })
    }
  },
  methods: {
    changeSlide(data){
      this.$router.push(data);
    },
    dey() {
      this.classs = 0;
      // console.log(this.classs);
      this.$axios({
        url:
          this.api +
          "/v1/rank/room/contribution?uid=" +
          this.roomids +
          "&rankType=daily",
        method: "GET",
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }).then((res) => {
        //   console.log(res);
        this.paihangbanData = res.data.data;
      });
    },
    month() {
      this.classs = 1;
      //   console.log(this.classs);
      this.$axios({
        url:
          this.api +
          "/v1/rank/room/contribution?uid=" +
          this.roomids +
          "&rankType=month",
        method: "GET",
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }).then((res) => {
        //   console.log(res);
        this.paihangbanData = res.data.data;
      });
    },
    sum() {
      this.classs = 2;
      //   console.log(this.classs);
      this.$axios({
        url:
          this.api +
          "/v1/rank/room/contribution?uid=" +
          this.roomids +
          "&rankType=total",
        method: "GET",
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }).then((res) => {
        //   console.log(res);
        this.paihangbanData = res.data.data;
      });
    },
    //   获取用户id
    roomid(e) {
      this.roomids = e;
      this.Ranking(e);
    },
    // 获取排行榜数据
    Ranking(e) {
      // console.log(e);
      this.$axios({
        url:
          this.api + "/v1/rank/room/contribution?uid=" + e + "&rankType=total",
        method: "GET",
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }).then((res) => {
        //   console.log(res);
        this.paihangbanData = res.data.data;
      });
    },
    dianji(e) {
      this.b = e;
    },
    Mingcheng(e, i) {
      // console.log(e,i);
      if (e == 0 && i == 0) {
        this.$router.push("/personalc");
      }
      if (e == 0 && i == 1) {
        this.$router.push("/wodeguanzhu");
      }
      if (e == 0 && i == 2) {
        this.$router.push("/wodefensi");
      }
      if (e == 0 && i == 3) {
        this.$router.push("/lishiguankan");
      }
      if (e == 0 && i == 4) {
        this.$router.push("/wodezichan");
      }
      if (e == 0 && i == 5) {
        this.$router.push("/wodexinxi");
      }
      if (e == 1 && i == 0) {
        this.$router.push("/shezhiguanliyuan");
      }
      if (e == 1 && i == 1) {
        this.$router.push("/guanlijinyan");
      }
      if (e == 1 && i == 2) {
        this.$router.push("/tianjiazhiboyuan");
      }
      if (e == 2 && i == 0) {
        this.$router.push("/wodeshouyi");
      }
      // if (e == 2&&i == 1) {
      //     this.$router.push('/yonghupaihangbang')
      // }
      // if (e == 3&&i == 0) {
      //     this.$router.push('/shipinfabu')
      // }
      // if (e == 3&&i == 1) {
      //     this.$router.push('/ziyuanguanli')
      // }
      if (e == 3 && i == 0) {
        this.$router.push("/zhiboshuju");
      }
      // if (e==4&&i==1) {
      //     this.$router.push('/shipinshuju')
      // }
    },
  },
  components: {
    Nav,
    slide
  },
};
</script>

<style scoped lang='scss'>
.personal-bottom-bottom-left .el-collapse {
  width: 100%;
  background: #f7f8fa;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
.personal {
  width: 100vw;
  background: #f7f8fa;
   .title_box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .lines {
        display: inline-block;
        width: 4px;
        margin-right: 6px;
        border-radius: 4px;
        height: 20px;
        background: #721edc;
      }
      span {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }
    }
  .xzcxzcxz {
    color: rgba(114, 30, 220, 1) !important;
  }
  .personal-bottom {
    background-color: #f7f8fa;
  }
  .personal-bottom-top {
    width: 100%;
    height: 60px;
    min-width: 1240px;
    background-color: #fff;
  }
  .personal-bottom-top-div {
    width: 1240px;
    height: 60px;
    margin: 0 auto;
    color: #333;
    font-size: 23px;
    line-height: 60px;
    display: flex;
    align-items: center;
  }
  .personal-bottom-top-div-div {
    width: 6px;
    height: 50px;
    background-color: #721edc;
    border-radius: 6px;
  }
}
.personal-bottom-bottom {
  width: 1200px;
  height: calc(100vh - 105px);
  margin: 0 auto;
  display: flex;
  background-color: #f7f8fa;
  min-width: 1200px;
  .personal-bottom-bottom-left {
    width: 190px;
    height: 100%;
    background-color: #fff;
    margin-top: 16px;
    color: #333;
    .myel-collapse-item {
      width: 190px;
    }
    .prent_item {
      text-align: center;
      width: 100%;
      height: 100%;
      display: flex;
      .parent_icon {
        display: flex;
        align-items: center;
      }
      .parent_name {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;
      .child_img {
        display: flex;
        align-items: center;
      }
      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
.personal-bottom-bottom-right {
  margin-left: 12px;
  height: 100%;
  flex: 2;
  max-width: 998px;
  background-color: #fff;
  padding: 30px 20px;
  box-sizing: border-box;
  margin-top: 16px;
  .personal-bottom-bottom-right-top {
    background-color: #fff;
    display: flex;
    align-items: center;
  }
  .xinxi {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .xinxi:hover {
    color: #721edc;
  }

  .maxtitle {
    font-size: 20px !important;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600 !important;
    color: #333333;

    span{
      font-weight: 600 !important;
      color: #333333;
    }
  }
}
.personal-bottom-bottom-right-bottom {
  flex: 2;
  height: calc(94% - 15px);
  box-sizing: border-box;
  margin-top: 25px;


  padding-top: 25px;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  .waiceng {
    display: flex;
    align-items: center;
  }
  .table_list {
    box-sizing: border-box;
    color: #ffffff;
    margin-top: 25px;
  }
  .tb_item{
    padding:0 12px;

      line-height: 47px;
      padding-left: 10px;
      display: flex;
      color: rgba(102, 102, 102, 1);
      width: 100%;
      height: 47px;
      background-color: #F7F8FA;
      border-bottom: 1px solid rgba(0, 0, 0, .1);
  }
  .tb_header {
    padding:0 12px;
    min-width: 958px;
    height: 34px;
    background: #faf6ff;
    line-height: 34px;
    display: flex;
    height: 34px;
    font-weight: 400;
    color: #333333;
    font-size: 16px;
  }
  .all_list {
    margin-right: 15px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    width: 68px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #dadada;
    border-radius: 4px;
    border-radius: 4px;
  }
  .detaultItem{
    background: rgba(114, 30, 220, 1) !important;
  }

  .active_list {
    background: rgba(114, 30, 220, 1) !important;
  }
  .month_list {
    margin-left: 15px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 28px;
    width: 60px;
    height: 28px;
    background: #464646;
    border-radius: 4px;
  }
  .day_list {
    margin-left: 15px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 28px;
    width: 60px;
    height: 28px;
    background: #464646;
    border-radius: 4px;
  }
}
.daohang {
  display: flex;
  color: white;
  width: 600px;
}
.xinxi {
  display: flex;
  align-items: center;
  font-size: 24px;
}
.personal-bottom-bottom-right-bottom-top {
  display: flex;
  height: 130px;
  border-bottom: 1px #464646 solid;
}
.personal-bottom-bottom-right-bottom-center1 {
  margin-top: 15px;
  height: 100px;
  border-bottom: 1px #464646 solid;
}
.personal-bottom-bottom-right-bottom-center2 {
  margin-top: 15px;
  /* height: 100px; */
  width: 100%;
}
.biao {
  width: 16px;
  height: 16px;
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
}
</style>
<style>
.colorBiao {
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
}
.a {
  background-color: #721edc;
}
.personal-bottom-bottom-left .el-collapse-item__header {
  box-sizing: border-box;
  padding-left: 20px;
  background-color: #fff;
  border-bottom: 0px solid #ebeef5;
  color: #333;
}
.personal-bottom-bottom-right .el-collapse-item__header {
  background: #000 !important;
}
.el-collapse-item__wrap {
  background-color: #f7f8fa !important;
}

.personal-bottom-bottom-left .is-active {
  color: rgba(114, 30, 220, 1);
}
.personal-bottom-bottom-left .el-collapse-item__content {
  padding-bottom: 0px;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  border-bottom: 0px solid #ebeef5;
}
.personal-bottom-bottom-left .el-collapse-item__content > div {
  text-align: center;
}

.personal-bottom-bottom-left .el-collapse {
  width: 100%;
  background: #f7f8fa;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/component/Yonghupaihangbang.vue